import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OperateSidebarService {

  private readonly groupListApi = '/api/house_group/group_list';

  private readonly typeListApi = '/api/house_type/all';

  private readonly houseListApi = '/api/reservation/house_list';
  private readonly batchSyncInventoryApi = '/api/calendar/batch_set_house_type_inventory';
  private readonly bookByHandApi = '/api/reservation/book_by_hand';
  private readonly guestListApi = '/api/client/list';
  private readonly hourOrdersApi = '/api/reservation/hour_reservations';
  private readonly currencyApi = '/api/transaction/get_currency';
  private readonly configApi = '/api/house_status_setting/get';
  constructor(private http: HttpClient) { }

  fetchGroupList () {
    return this.http.get(this.groupListApi) as Observable<any>;
  }

  fetchCurrencyList(params = { only_in_record: 0 }) {
    const query = new HttpParams().append(
      "only_in_record",
      `${params.only_in_record}`
    );
    return this.http.get(this.currencyApi, { params: query }) as Observable<
      Response
    >;
  }

  fetchConfig () {
    return this.http.get(this.configApi) as Observable<any>;
  }

  fetchTypeList () {
    return this.http.get(this.typeListApi) as Observable<any>;
  }

  fetchHouseList (params) {
    const query = new HttpParams()
      .append('page', '1')
      .append('page_size', '1000')
      .append('format', 'batch_set_available')
      .append('house_type_id', `${params.house_type_id}`)
      .append('group_id', `${params.group_id}`);
    return this.http.get(this.houseListApi, { params: query }) as Observable<any>;
  }

  batchSetTypeInventory (params) {
    return this.http.post(this.batchSyncInventoryApi, params) as Observable<any>;
  }

  createManualOrder (params) {
    return this.http.post(this.bookByHandApi, params) as Observable<any>;
  }

  fetchHourOrders (params) {
    const query = new HttpParams({
      fromObject: params
    });
    console.log('query: ', query);
    return this.http.get(this.hourOrdersApi, { params: query }) as Observable<any>;
  }

  fetchGuestList (params) {
    const query = new HttpParams({
      fromObject: params
    })

    return this.http.get(this.guestListApi, { params: query }) as Observable<any>;
  }

}
